<div #mainContainer style="width: 100%; padding: 20px">
    <div class="controls">
        @if (!isEditMode()) {
            <button class="button primary" (click)="enterEditMode()">{{ 'dashboard.visuals.actions.editDashboard' | translate }}</button>
        }

        @if (isEditMode()) {
            <button class="button primary" (click)="exitEditMode(true)">{{ 'dashboard.visuals.actions.saveDashboard' | translate }}</button>
            <button class="button secondary" (click)="exitEditMode(false)">
                {{ 'dashboard.visuals.actions.discardChanges' | translate }}
            </button>
            <button class="button primary" (click)="openItemAddingModal()">
                <i class="fa fa-plus iconSmall"></i>{{ 'dashboard.visuals.actions.addWidgets' | translate }}
            </button>
        }
    </div>

    @if (visualsDashboardService.loadedDashboardData()) {
        @if (visualsDashboardService.dashboard().length > 0) {
            <div #gridContainer [style.max-width.px]="dashboardContainerWidth()">
                <gridster [options]="options()">
                    @for (item of visualsDashboardService.dashboard(); track item.htmlId; let index = $index) {
                        <gridster-item [item]="item">
                            <app-visual-dashboard-item-wrapper
                                [isEditMode]="isEditMode()"
                                (removeWidget)="removeItem(item)"
                                (editWidget)="openItemEditModal(item)"
                                [widget]="item"
                            ></app-visual-dashboard-item-wrapper>
                        </gridster-item>
                    }
                </gridster>
            </div>
        } @else {
            <div class="empty-state">
                <div class="empty-state-icon">
                    <i class="fa-light fa-grid-2"></i>
                </div>
                <h3 class="empty-state-title">{{ 'dashboard.visuals.emptyState.title' | translate }}</h3>
                <p class="empty-state-description">{{ 'dashboard.visuals.emptyState.description' | translate }}</p>
                <div class="empty-state-steps">
                    <div class="step">
                        <span class="step-number">1</span>
                        <span class="step-text">{{ 'dashboard.visuals.emptyState.step1' | translate }}</span>
                    </div>
                    <div class="step">
                        <span class="step-number">2</span>
                        <span class="step-text">{{ 'dashboard.visuals.emptyState.step2' | translate }}</span>
                    </div>
                    <div class="step">
                        <span class="step-number">3</span>
                        <span class="step-text">{{ 'dashboard.visuals.emptyState.step3' | translate }}</span>
                    </div>
                </div>
                <p class="empty-state-cta-text">{{ 'dashboard.visuals.emptyState.ctaText' | translate }}</p>
                <button class="button primary" (click)="getStarted()">
                    <i class="fa fa-plus iconSmall"></i>
                    {{ 'dashboard.visuals.emptyState.getStarted' | translate }}
                </button>
            </div>
        }
    }
</div>
